import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { MultiSelectComponent } from "@syncfusion/ej2-angular-dropdowns";
import { getTranslation } from "../../utils/utils";

@Component({
  selector: "rs-confirm-select",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class ConfirmSelectComponent implements OnInit, OnChanges {
  @ViewChild("comfirmSelect", { static: false })
  comfirmSelect: MultiSelectComponent;
  @Input() value;
  @Input() dataSource = [];
  @Input() disabled = false;
  @Input() fields = { text: "Game", value: "Id" };
  @Input() placeholder;
  @Input() showSelectAll = true;

  @Output() valueChange = new EventEmitter();

  translation;
  selectedItems = [];
  isInteracted = false;

  ngOnInit() {
    this.getInfo();
    this.resetSelectedItems();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value && !changes.value.firstChange) {
      this.resetSelectedItems();
    }
  }

  getInfo() {
    this.translation = getTranslation();
  }

  resetSelectedItems() {
    this.selectedItems = JSON.parse(JSON.stringify(this.value || []));
    if (this.comfirmSelect) {
      this.comfirmSelect.value = this.selectedItems;
    }
  }

  onCancel() {
    this.isInteracted = true;
    this.resetSelectedItems();
    this.comfirmSelect.hidePopup();
  }

  onApply() {
    this.isInteracted = true;
    const val = this.comfirmSelect.value;
    this.valueChange.emit(val);
    this.comfirmSelect.hidePopup();
  }

  onClose(e) {
    if (this.isInteracted) {
      this.isInteracted = false;
    } else {
      this.resetSelectedItems();
    }
  }
}
